module.exports = __webpack_public_path__ + "static/img/bztLogo.60537b3c.png";